module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_page_add-3fa75b9a988dcbc0abc7c9caeb03de5b.png";